import React, { useEffect } from "react";
import { Row, Col, Card, Typography } from "antd";
import TeamPicture from "../../Assets/images/team-picture.jpg";

const { Paragraph, Text, Title } = Typography;

type HomeProps = {
  updateSidebar: (e: string) => void;
  isMobile: boolean;
};

export default function Home(props: HomeProps) {
  const { updateSidebar, isMobile } = props;

  useEffect(() => {
    updateSidebar("Home");
  }, [updateSidebar]);

  return (
    <div style={{ padding: isMobile ? 8 : 16 }}>
      <Row gutter={[16, 16]}>
        <Col span={24} xl={16}>
          <Card bodyStyle={{ padding: isMobile ? 8 : 16 }}>
            <img
              style={{
                borderRadius: 8,
                width: "100%",
                display: "block",
              }}
              src={TeamPicture}
              alt="Runablaze Iowa athletes after a team road race"
            />
          </Card>
        </Col>

        <Col span={24} xl={8} style={{ display: "flex" }}>
          <Card
            style={{ width: "100%" }}
            title={
              <div>
                <Title
                  level={3}
                  style={{ margin: 0, fontWeight: 600, letterSpacing: 0.3 }}
                >
                  Our Mission
                </Title>
                <Text type="secondary">Des Moines, Iowa • Founded 2006</Text>
              </div>
            }
          >
            <Paragraph style={{ fontSize: 16, marginBottom: 12 }}>
              Runablaze Iowa is a post-collegiate distance running club based
              out of Des Moines with members from across the state. We support
              Iowa-based runners who want to keep competing at a high level on
              the roads, track, and cross country.
            </Paragraph>

            <Paragraph style={{ fontSize: 16, marginBottom: 12 }}>
              We strive to:
            </Paragraph>

            <ul style={{ paddingLeft: 20, marginBottom: 16, fontSize: 16 }}>
              <li>Provide coaching and a competitive team environment</li>
              <li>Help cover travel and race expenses for key events</li>
              <li>
                Compete at local, regional, and national championship races
              </li>
            </ul>

            <Paragraph style={{ fontSize: 16, marginBottom: 20 }}>
              Our goal is to give Iowa’s best distance runners the support they
              need to keep chasing big results after college.
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
